import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Categories,CatActionTypes,CatSuccess,CatFailure} from '../actions/categoriesActions'; 
import { Observable} from 'rxjs';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';

import { tap } from 'rxjs/operators';

import { CategoriesService } from '../../app/pages/categories/categories.service';



@Injectable()
export class CategoryEffects {

  constructor(
    private actions: Actions,
    private categoreisService: CategoriesService
  ) {}


   @Effect()
   Categories: Observable<any> = this.actions
    .ofType(CatActionTypes.RETRIEVE_CATEGORIES)
    .map((action: Categories) => action)
    .switchMap(payload => {
      return this.categoreisService.categories().map((data) => {
        console.log("data",data)
        return new CatSuccess({categories: data.data});
      })
      .catch((error) => {
        return Observable.of(new CatFailure({ error: error }));
      });
    });


    @Effect({ dispatch: false })
    CatSuccess: Observable<any> = this.actions.pipe(
    ofType(CatActionTypes.CAT_SUCCESS)
    ); 
    @Effect({ dispatch: false })
    CatFailure: Observable<any> = this.actions.pipe(
      ofType(CatActionTypes.CAT_FAILURE)
    );
}
